var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.38419e-7,
    y: 0.0237732,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 2.38419e-07 0.0237732)",
    fill: "white",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 5L5 5L5 27.2L27.2 27.2L27.2 5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1932 13.1207L21.2491 13.1207L21.2491 19.0648L27.1932 19.0648L27.1932 13.1207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0721 5L16.1001 10.1477L21.2478 13.1198L24.2199 7.97204L19.0721 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9502 19.0609L7.97812 24.2087L13.1259 27.1807L16.0979 22.033L10.9502 19.0609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9509 13.1207L5.00679 13.1207L5.00679 19.0648L10.9509 19.0648L10.9509 13.1207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2492 19.0656L16.1015 22.0377L19.0736 27.1854L24.2213 24.2134L21.2492 19.0656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1275 5.00253L7.97974 7.97457L10.9518 13.1223L16.0995 10.1503L13.1275 5.00253Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmni);
export default __webpack_public_path__ + "static/media/OMNI.9e3e8ec42a7c6b6e2b66b60eccb0da14.svg";
export { ForwardRef as ReactComponent };